/**
 * Opengater section token store.
 *
 * The user chose a SEPARATE login for the Opengater Manager: the section
 * authenticates against Opengater's own GlobalAuth (VITE_OG_AUTH_URL) and holds
 * its own JWT pair, independent of the panel's primary tokens in `@/auth/tokens`.
 *
 * We namespace under `og_` so the two never collide — logging out of one must
 * not touch the other, and a panel-token refresh must not overwrite the OG one.
 * All five Opengater services trust the SAME OG access token (they share the
 * GlobalAuth issuer), so one pair covers the whole section.
 */
/** Fired on window when the Opengater session ends (failed refresh, logout). */
export const OG_AUTH_EXPIRED_EVENT = 'og:auth-expired';
/** Fired whenever the namespaced token pair is written or cleared. */
export const OG_AUTH_CHANGED_EVENT = 'og:auth-changed';
function emitOgAuthChanged() {
    window.dispatchEvent(new CustomEvent(OG_AUTH_CHANGED_EVENT));
}
const ACCESS_KEY = 'og_access_token';
const REFRESH_KEY = 'og_refresh_token';
const EMAIL_KEY = 'og_email';
export function getOgAccessToken() {
    return localStorage.getItem(ACCESS_KEY);
}
export function getOgRefreshToken() {
    return localStorage.getItem(REFRESH_KEY);
}
export function getOgEmail() {
    return localStorage.getItem(EMAIL_KEY);
}
export function saveOgTokens(accessToken, refreshToken) {
    localStorage.setItem(ACCESS_KEY, accessToken);
    if (refreshToken)
        localStorage.setItem(REFRESH_KEY, refreshToken);
    emitOgAuthChanged();
}
export function saveOgEmail(email) {
    localStorage.setItem(EMAIL_KEY, email);
}
export function clearOgTokens() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(EMAIL_KEY);
    emitOgAuthChanged();
}
export function isOgAuthenticated() {
    return !!getOgAccessToken();
}
